var _VariantStyles;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Variants = {
  HEADING: "heading",
  HEADING_LARGE: "headingLarge",
  SECONDARY: "secondary",
  PRIMARY: "primary",
  SMALL: "small",
  HIGHLIGHT: "highlight"
};
var VariantStyles = (_VariantStyles = {}, _defineProperty(_VariantStyles, Variants.HEADING, {
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: 600,
  color: "#24292F"
}), _defineProperty(_VariantStyles, Variants.HEADING_LARGE, {
  fontSize: "16px",
  lineHeight: "16px",
  fontWeight: 600,
  color: "#24292F"
}), _defineProperty(_VariantStyles, Variants.SECONDARY, {
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: 400,
  color: "#6E7781"
}), _defineProperty(_VariantStyles, Variants.PRIMARY, {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "14px",
  color: "#24292F"
}), _defineProperty(_VariantStyles, Variants.SMALL, {
  fontSize: "12px",
  lineHeight: "12px",
  fontWeight: 400,
  color: "#24292F"
}), _defineProperty(_VariantStyles, Variants.HIGHLIGHT, {
  fontSize: "14px",
  fontWeight: 400,
  color: "#101010"
}), _VariantStyles);

export { VariantStyles, Variants };
